import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MaterialForm_Material_Create_Mutation = graphql(`
  mutation MaterialForm_Material_Create(
    $material: MaterialInput!
    $versionData: VersionDataInput
  ) {
    createMaterial(doc: $material, versionData: $versionData) {
      _id
    }
  }
`);

export type MaterialInput = VariablesOf<
  typeof MaterialForm_Material_Create_Mutation
>['material'];

export type MaterialForm_Material_Create_Result = ResultOf<
  typeof MaterialForm_Material_Create_Mutation
>;

export const useCreateMaterialMutation = () =>
  useGraphQLMutation(MaterialForm_Material_Create_Mutation);
